import memoizeOne from 'react-utils/memoizeOne';
import { getMetricsObjectTypeId } from './getMetricsObjectTypeId';
export const getAdditionalMetricsDimensions = memoizeOne((objectTypeId, pageType) => {
  const metricsObjectTypeId = getMetricsObjectTypeId(objectTypeId !== null && objectTypeId !== void 0 ? objectTypeId : '');
  return Object.assign({}, objectTypeId ? {
    metricsObjectTypeId
  } : {}, pageType ? {
    pageType
  } : {});
});